
import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from 'vue';
import DateOfCalendar from '@/class/DateOfCalendar';
import { useStore } from '@/store';
import useQueryPostApi from '@/composables/useQueryPostApi';
import PostsQueryInput from '@/interface/graphql/PostsQueryInput';
import useMonthPanel from '@/composables/useMonthPanel';
import CalendarBodyDate from './CalendarBodyDate.vue';
import SvgIcon from '../SvgIcon.vue';

export default defineComponent({
  components: { CalendarBodyDate, SvgIcon },
  name: 'CalendarBodyDates',
  setup() {
    const store = useStore();
    const weekListOfCurrentMonth = computed(() => store.state.currentMonth.calendar);

    const dayList = reactive(['日', '一', '二', '三', '四', '五', '六']);

    const variable: Ref<PostsQueryInput> = ref({
      from: store.state.currentMonth.firstDateString,
      to: store.state.currentMonth.lastDateString,
    });

    watch(
      () => store.state.currentMonth,
      (newVal, oldVal) => {
        if (newVal.equals(oldVal)) return;
        variable.value.from = store.state.currentMonth.firstDateString;
        variable.value.to = store.state.currentMonth.lastDateString;
      },
    );

    const { posts: source, loading } = useQueryPostApi(variable);
    const posts = computed(() => loading.value ? [] : source.value);

    const getPosts = computed(() => (dateOfCalendar: DateOfCalendar) => {
      if (posts.value.length > 0) {
        const { date } = dateOfCalendar;
        if (date) {
          dateOfCalendar.posts = posts.value.filter(post => {
            const fromStr = post.from.split('-').map(s => Number(s));
            const toStr = post.to.split('-').map(s => Number(s));
            const from = new Date(fromStr[0], fromStr[1] - 1, fromStr[2]);
            const to = new Date(toStr[0], toStr[1] - 1, toStr[2]);
            return date.getTime() >= from.getTime() && date.getTime() <= to.getTime();
          });
        }
      } else {
        dateOfCalendar.posts = [];
      }

      return dateOfCalendar;
    });

    const { goToAddMonth } = useMonthPanel();

    return {
      dayList,
      weekListOfCurrentMonth,
      getPosts,
      loading,
      goToAddMonth,
    };
  },
});
